export type PreviewKind = 'pdf' | 'image';

const PREVIEW_TYPES: Record<string, { kind: PreviewKind; mime: string }> = {
  pdf: { kind: 'pdf', mime: 'application/pdf' },
  png: { kind: 'image', mime: 'image/png' },
  jpg: { kind: 'image', mime: 'image/jpeg' },
  jpeg: { kind: 'image', mime: 'image/jpeg' },
};

const previewType = (fileName: string) => {
  const dot = fileName.lastIndexOf('.');
  if (dot < 0) return null;
  const extension = fileName.slice(dot + 1).toLowerCase();
  return Object.hasOwn(PREVIEW_TYPES, extension) ? PREVIEW_TYPES[extension] : null;
};

/** How the app can show a file, or null when it can only be downloaded */
export const previewKind = (fileName: string): PreviewKind | null => previewType(fileName)?.kind ?? null;

/**
 * The type a preview is rendered under. It comes from the extension, never from the response: the
 * stored content type is whatever the uploading client sent, and a blob of type text/html in a frame
 * would run with this origin's access to the local token (Decision 39). The API validates the extension.
 */
export const previewMimeType = (fileName: string): string | null => previewType(fileName)?.mime ?? null;

/** The page a field's location names ("page N"); null for "part N" or anything else */
export const pageFromLocation = (location: string | undefined): number | null => {
  const match = /^page ([1-9]\d*)$/.exec(location ?? '');
  if (!match) return null;
  const page = Number(match[1]);
  return Number.isSafeInteger(page) ? page : null;
};
